import styled from 'styled-components';

export const ActiveElement = styled.span`
  cursor: pointer;
`;
